import service from '@/services/superaccess'

const ProfilesModule = {
  state: {
    profiles: [],
    levels: [],
    edit_profile: {},
    cleanModal: false,
    stateEdit: false
  },
  mutations: {
    addProfiles (state, profiles) {
      state.profiles = profiles
    },
    addLevels (state, levels) {
      state.levels = levels
    },
    editProfile (state, profile) {
      state.edit_profile = profile
    },
    updateStateProfile (state, data) {
      let profile = state.profiles.findIndex(p => p.id === data.profileId + '')
      state.profiles[profile].state = data.state
    },
    updateProfiles (state, data) {
      let profile = {
        id: data.id,
        name: data.model.name,
        level: data.model.level,
        description: data.model.description,
        state: data.model.state,
        permissions: data.model.permissions
      }
      state.profiles.push(profile)
    },
    setModalStatus (state, status) {
      state.cleanModal = status
    },
    setEditStatus (state, status) {
      state.stateEdit = status
    }
  },
  getters: {
    allProfiles (state) {
      return state.profiles
    },
    allLevels (state) {
      return state.levels
    },
    getEditProfile (state) {
      return state.edit_profile
    },
    activateProfiles (state) {
      let result = []
      if (state.profiles.length > 0) {
        state.profiles.forEach(element => {
          if (element.state === 1) {
            result.push(element)
          }
        })
      }
      return result
    },
    getProfileModalStatus (state) {
      return state.cleanModal
    },
    getEditStatus (state) {
      return state.stateEdit
    }
  },
  actions: {
    retrieveGroupPermissionsByProfile (context, data) {
      return service.get(`/api/profile/${data}/groups`, context)
    },
    updateGroupPermissionProfile (context, data) {
      return service.post('/api/profile/groups/create', context, data)
    },
    profiles (state, data) {
      return new Promise((resolve, reject) => {
        service.post('/api/profile/all', state, {}).then((result) => {
          state.commit('addProfiles', result.data)
          resolve(true)
        }, error => {
          console.log(error)
        })
      })
    },
    saveProfile (state, data) {
      return new Promise((resolve, reject) => {
        service.post('/api/profile/create', state, { profile: data }).then((result) => {
          if (result.status === 200) {
            if (data.permissions) {
              state.dispatch('addPermissionsToProfile', {permissions: data.permissions, profile: result.data})
            }
            state.commit('updateProfiles', {model: data, id: result.data})
            resolve(true)
          } else {
            console.log(result)
          }
        }, error => {
          console.log(error)
        })
      })
    },
    editProfile (commit, data) {
      return new Promise((resolve, reject) => {
        service.put('/api/profile/modify/' + data.id, commit, { profile: data })
          .then((result) => {
            if (result.status === 200) {
              resolve(true)
            } else {
              reject(result)
              console.log(result)
            }
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      })
    },
    addPermissionsToProfile (commit, data) {
      return new Promise((resolve, reject) => {
        service.post('/api/permission-profile/create', commit, { permission_profile: data, isProfile: true }).then((result) => {
          if (result.status === 200) {
            console.log('addProfile')
          }
          // console.log('notAddedProfile')
        })
      })
    },
    updateStateProfile (state, profile) {
      return service.post('/api/profile/change/' + profile, state)
    },
    updateModalStatus (context, payload) {
      context.commit('setModalStatus', payload)
    },
    updateEditStatus (context, payload) {
      context.commit('setEditStatus', payload)
    },
    levels (context) {
      service.get('/api/profile/new', context).then((result) => {
        context.commit('addLevels', result.data.levels)
      })
    }
  }
}

export default ProfilesModule



// WEBPACK FOOTER //
// app/javascript/src/store/profiles.js